import { render, staticRenderFns } from "./procurementContract.vue?vue&type=template&id=59b17994&scoped=true"
import script from "./procurementContract.vue?vue&type=script&lang=js"
export * from "./procurementContract.vue?vue&type=script&lang=js"
import style0 from "./procurementContract.vue?vue&type=style&index=0&id=59b17994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b17994",
  null
  
)

export default component.exports